import React from 'react';

const V3ContentScreenContext = React.createContext<{
  content: ContentIndexTypes.ContentItem | undefined;
  isIndexScreen: boolean;
}>({
  content: undefined,
  isIndexScreen: false,
});

export default V3ContentScreenContext;
